import React from "react";
import { THEME_COLORS } from "../../../../../color";
import { useSelector } from "react-redux";
const HorizontalBarChart = ({
  icon,
  title = "Chart",
  categories = [],
  data = [],
  details = [],
  valueLabel = "Value",
  percentLabel = "Percent",
  tooltipUnit = "",
  barColors = [
    THEME_COLORS.lightblue, // 2019
    THEME_COLORS.green, // 2020
    THEME_COLORS.darkblue, // 2021
    THEME_COLORS.yellow, // 2022
    THEME_COLORS.pink, // 2023
  ],
  height = 250,
  showDetails = true,
  title1,
  xh = "",
  yh = "",
}) => {
  const maxValue = Math.max(...data, 1); // Avoid zero division
  const { user } = useSelector((state) => state.auth);
  const isPermissionCompleted = user?.isCompleted;
  //console.log(isPermissionCompleted, "isPermissionCompleted");

  return (
    <div className="bg-white  p-3 sm:p-4 shadow-sm rounded-2xl">
      {/* Header Section */}
      <div className="flex items-center justify-between mb-1">
        <div className="flex items-center">
          <div className="rounded-md mr-2">
            <span className="text-[#06513D] text-2xl">{icon}</span>
          </div>
          <div>
            <h2 className="font-bold text-[#06513D] text-sm sm:text-base capitalize">
              {title}
            </h2>
            {title1 && (
              <h5
                className="text-xs sm:text-sm font-medium capitalize"
                style={{ color: THEME_COLORS.green }}
              >
                {title1}
              </h5>
            )}
          </div>
        </div>
      </div>

      {/* Chart Content */}
      <div
        className={`space-y-1 ml-2 ${
          !isPermissionCompleted ? "blur-sm opacity-60 pointer-events-none" : ""
        }`}
      >
        {/* Headers */}
        <div className="flex justify-end space-x-4 text-[10px] text-gray-600 font-medium pb-1">
          <span className="w-[112px] text-center leading-tight">
            {valueLabel}
          </span>
          <span className="w-[92px] text-center leading-tight">
            {percentLabel}
          </span>
        </div>

        {/* Chart Bars */}
        {data.map((value, index) => {
          const category = categories[index] || `Item ${index + 1}`;
          const detail = details[index] || {
            value: value,
            percent: ((value / maxValue) * 100).toFixed(1),
          };
          const color = barColors[index % barColors.length];
          const parsedPercent = parseFloat(detail.percent);
          const displayPercentage = !isNaN(parsedPercent)
            ? parsedPercent
            : value === 0
              ? 0
              : (value / maxValue) * 100;

          return (
            <div key={index} className="flex items-center">
              {/* Color Indicator */}
              <div className="text-[0.7rem] font-normal text-gray-700 w-40">
                {category}
              </div>

              {/* Progress Bar */}
              <div className="flex-1 mr-4">
                <div className="bg-gray-100 rounded-full h-1.5 overflow-hidden w-[90%] ml-2">
                  <div
                    className="h-1.5 transition-all duration-1000 ease-out"
                    style={{
                      width: `${displayPercentage}%`,
                      backgroundColor: value === 0 ? "transparent" : color,
                    }}
                  />
                </div>
              </div>

              {/* Category Label and Values */}
              <div className="flex items-center space-x-4">
                {/* Value Badge */}
                <div
                  className="px-2 py-[0.1rem] rounded-full w-[112px] text-center"
                  style={{
                    backgroundColor: `${color}33`, // 20% opacity
                    border: `1px solid ${color}`,
                  }}
                >
                  <span className="text-xs font-light text-gray-700 whitespace-nowrap">
                    {detail.value}
                  </span>
                </div>

                {/* Percentage Badge */}
                <div
                  className="px-2 py-[0.1rem] rounded-full w-[92px] text-center"
                  style={{
                    backgroundColor: `${color}33`, // 20% opacity
                    border: `1px solid ${color}`,
                  }}
                >
                  <span className="text-xs font-light text-gray-700 whitespace-nowrap">
                    {detail.percent}
                  </span>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Summary Section (if showDetails is true) */}
      {showDetails && details.length > 0 && (
        <div
          // className="mt-4 pt-2 border-t border-gray-200"
          className={`mt-4 pt-2 border-t border-gray-200 ${
            !isPermissionCompleted
              ? "blur-sm opacity-60 pointer-events-none"
              : ""
          }`}
        >
          <div
            className="flex justify-end items-center text-sm font-semibold"
            style={{ color: THEME_COLORS.green }}
          >
            <div className="flex items-center space-x-4">
              <div className="w-[112px] text-center">
                {details
                  .reduce((acc, cur) => acc + parseFloat(cur.value || 0), 0)
                  .toFixed(
                    Math.max(
                      1,
                      ...details.map((d) => {
                        const str = String(d.value || "");
                        const parts = str.split(".");
                        return parts.length > 1 ? parts[1].length : 0;
                      }),
                    ),
                  )}
              </div>
              <div className="w-[92px] text-center">
                {details
                  .reduce((acc, cur) => acc + parseFloat(cur.percent || 0), 0)
                  .toFixed(0)}
                %
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default HorizontalBarChart;
